<template>
  <div class="trade-order-block">
    <div class="order-header">
      <!-- 订单基本信息 -->
      <div class="order-name">
        <span>{{ setOrderName() }}</span>
        <span v-if="showStep" class="order-close">订单已关闭</span>
      </div>
      <div class="order-time">
        <div>下单时间：{{ tradeApplyInfoVO.applyDate | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}</div>
        <div style="text-align: right">
          <div class="order-number">
            渠道项目订单编号：{{ tradeApplyInfoVO.applyNumber }}
            <img v-if="tradeApplyOrderVO && tradeApplyOrderVO.originPerfectApplyOrderInfo" src="../../../assets/images/extend-box.png" />
          </div>
          <div style="margin-top: 5px" v-if="tradeApplyInfoVO.sapPoNumber">PO：{{ tradeApplyInfoVO.sapPoNumber }}</div>
        </div>
      </div>
      <div class="Disabletheinformation"></div>
      <div class="order-reject">
        <div v-show="rejectName">
          <span>{{ processAction === '03' ? '驳回人' : '关闭人' }}：</span>
          {{ rejectName }}
        </div>
        <div v-show="rejectRemark">
          <span>{{ processAction === '03' ? '驳回理由&具体理由说明' : '关闭理由&具体理由说明' }}：</span>
          {{ rejectRemark }}
        </div>
        <div v-show="forbiddenName"><span>禁用操作人：</span>{{ forbiddenName }}</div>
        <div v-show="forbiddenValue"><span>禁用理由：</span>{{ forbiddenValue }}</div>
        <div v-show="forbiddenRemark"><span>补充备注：</span>{{ forbiddenRemark }}</div>
      </div>

      <!-- 功能按钮 -->
      <div class="order-btn" v-show="canHandleLevel">
        <el-button v-show="canHandleReset" class="btn-red" size="small" @click="handleReset">重设供应商</el-button>
        <el-button v-show="canHandleResetQuota" class="btn-red" size="small" @click="handleResetQuota">重选预算</el-button>
        <el-button v-show="canHandleReject" class="btn-red" size="small" @click="handleReject">一键驳回</el-button>
        <el-button v-show="canHandleClose" class="btn-red" size="small" @click="handleClose">关闭订单</el-button>
      </div>

      <!-- 完美门店 TM关闭订单 -->
      <div class="order-btn" v-if="canPerfectClose">
        <el-button class="btn-red" size="small" @click="handleClose">关闭订单</el-button>
      </div>

      <!-- 弹窗提示 -->
      <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
        <span v-if="handleType === 'reset' || handleType === 'resetQuota'">{{ handleText }}</span>
        <el-row class="content-row" v-else>
          <el-col :span="6" style="padding-top: 7px; min-width: 100px"
            ><i v-if="handleType === 'reject' || handleType === 'close'" style="color: #c8102d; font-weight: 700; margin-right: 3px">*</i
            >{{ handleTips }}</el-col
          >
          <el-col :span="9">
            <el-input :placeholder="handleTips" style="width: 270px" type="textarea" v-model="rejectReason"></el-input>
          </el-col>
        </el-row>

        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"> 取 消 </el-button>
          <el-button class="btn-red" size="small" @click="handleConfirm"> 确 定 </el-button>
        </span>
      </el-dialog>

      <!-- 成功弹窗 -->
      <el-dialog title="提示" :visible.sync="succVisible" width="30%" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <span>{{ successText }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="returnList">返回</el-button>
          <el-button class="btn-red" size="small" @click="showInfo"> 查看详情 </el-button>
        </span>
      </el-dialog>
    </div>
    <div class="step-slot" v-if="!showStep">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'order-base-info',

  props: {
    tradeApplyOrderVO: {},
    tradeApplyInfoVO: {},
    tradeApplyBaseVO: {},
    perfectInfo: null,
    isMineApply: null
  },

  data () {
    return {
      handleText: '',
      handleType: '',
      handleTips: '',
      dialogVisible: false,
      succVisible: false,
      rejectReason: '',
      processRecordList: {},
      rejectName: '',
      rejectRemark: '',
      forbiddenName: '',
      forbiddenValue: '',
      forbiddenRemark: '',
      successText: '',
      canHandleLevel: false,
      canHandleReset: false,
      canHandleResetQuota: false,
      canHandleReject: false,
      canHandleClose: false,
      applyType: '',
      employeeLevel: null,
      defaultBuType: '',
      execTypeSub: '',
      applyStatus: '',
      solutionStatus: '',
      executionStatus: '',
      requirementStatus: '',
      processAction: null
    }
  },

  computed: {
    ...mapGetters(['userInfo']),

    showStep () {
      return this.tradeApplyInfoVO.applyStatus === '900'
    },

    canPerfectClose () {
      if (['107', '108'].includes(this.execTypeSub)) {
        return this.tradeApplyInfoVO.applyStatus === '100'
      } else {
        if (!this.tradeApplyInfoVO || !this.perfectInfo) return
        return this.tradeApplyInfoVO.applyStatus === '300' &&
          this.perfectInfo.orderStartTime > +new Date()
      }
    },
    isStarCustom () {
      return !!(this.execTypeSub === '202' && this.employeeLevel === 90)
    }
  },

  watch: {
    tradeApplyInfoVO: {
      handler: function (val, oldval) {
        this.applyType = this.tradeApplyOrderVO?.applyType
        this.employeeLevel = this.userInfo.employeeLevel
        this.defaultBuType = this.userInfo.defaultBuType
        if (this.tradeApplyOrderVO?.tradeApplyExecVO) {
          this.execTypeSub = this.tradeApplyOrderVO?.tradeApplyExecVO?.execTypeSub
        }

        //  驳回信息
        this.processRecordList = this.tradeApplyOrderVO?.processRecordList || []
        if (this.processRecordList.length) {
          const processRecordListLast = this.processRecordList[this.processRecordList.length - 1]
          this.processAction = processRecordListLast.processAction
          if (this.processAction === '03' || this.processAction === '90') {
            this.rejectName = processRecordListLast.processClientName
            this.rejectRemark = processRecordListLast.processReason ? processRecordListLast.processReason + ' | ' + processRecordListLast.processRemark : processRecordListLast.processRemark
          } else if (this.processAction === '10') {
            this.forbiddenName = processRecordListLast.processClientName
            this.forbiddenValue = processRecordListLast.processReasonValue
            this.forbiddenRemark = processRecordListLast.processRemark
          } else {
            this.rejectName = ''
            this.rejectRemark = ''
            this.forbiddenName = ''
            this.forbiddenValue = ''
            this.forbiddenRemark = ''
          }
        }

        this.applyStatus = this.tradeApplyInfoVO.applyStatus
        this.solutionStatus = this.tradeApplyInfoVO.solutionStatus
        this.executionStatus = this.tradeApplyInfoVO.executionStatus
        this.requirementStatus = this.tradeApplyInfoVO.requirementStatus

        this.canHandleLevel = false
        this.canHandleReset = false
        this.canHandleResetQuota = false
        this.canHandleReject = false
        this.canHandleClose = false

        this.setLevelAuth()
        this.setResetAuth()
        this.setResetQuotaAuth()
        this.setRejectAuth()
        this.setCloseAuth()
      },
      immediate: true, // 关键
      deep: true
    }
  },

  methods: {
    // 设置门店名称
    setOrderName () {
      if (this.tradeApplyOrderVO?.applyType === '04') {
        return this.tradeApplyOrderVO.tradeApplyExecPboDTO.tradePboCirclePocList.filter(
          item => {
            return item.pocType === 'main'
          }
        )[0].circlePocName
      } else if (this.tradeApplyOrderVO?.applyType === '02') {
        return this.tradeApplyInfoVO.eventSubject
      } else {
        if (this.tradeApplyOrderVO?.tradeApplyExecCoolerTrackVO) {
          return this.tradeApplyOrderVO.tradeApplyExecCoolerTrackVO.coolerItemName
        }
        return this.tradeApplyOrderVO?.basePocInfo?.pocName
      }
    },
    // 统一的按钮级别权限
    setLevelAuth () {
      if (
        (this.employeeLevel === 45 ||
          this.employeeLevel === 50 ||
          (this.defaultBuType === '03' && this.employeeLevel === 60)) ||
          this.isStarCustom && // Star店招计划 HQTM可操作
        this.applyStatus !== '900' &&
        !this.tradeApplyOrderVO?.tradeApplyExecStack &&
        !this.tradeApplyOrderVO?.tradeApplyExecPerfectVOList &&
        !this.tradeApplyOrderVO?.tradeApplyExecLemonInfo
      ) {
        this.canHandleLevel = true
      } else {
        this.canHandleLevel = false
      }
    },

    // 重设供应商权限
    setResetAuth () {
      // 店招类、ISP
      if (this.applyType === '01' || this.applyType === '03') {
        // 220 230 240 250 330 状态可重设供应商
        if (
          ((['220', '230', '240', '250'].includes(this.solutionStatus)) &&
            this.applyStatus === '200') ||
          (this.executionStatus === '330' &&
            !this.tradeApplyOrderVO?.tradeApplyExecCooler)
        ) {
          // 由TM及TM助理重设
          if (this.employeeLevel === 45 || this.employeeLevel === 50 || this.isStarCustom) {
            this.canHandleReset = true
          } else {
            this.canHandleReset = false
          }
        } else {
          this.canHandleReset = false
        }
      }
      // 批量化物料
      if (this.applyType === '02') {
        this.canHandleReset = false
      }
    },

    // 重选预算
    setResetQuotaAuth () {
      // 店招类、ISP
      if (this.applyType === '01' || this.applyType === '03') {
        // 260 270 280 状态可重选预算
        if (this.employeeLevel === 50 &&
          ['260', '270', '280'].includes(this.solutionStatus) &&
          this.applyStatus === '200' &&
          !this.tradeApplyOrderVO?.tradeApplyExecCooler
        ) {
          this.canHandleResetQuota = true
        } else {
          this.canHandleResetQuota = false
        }
      }
      // 批量化物料
      if (this.applyType === '02') {
        if (['260', '270', '280'].includes(this.solutionStatus) &&
          this.applyStatus === '200' &&
          this.isMineApply) {
          this.canHandleResetQuota = true
        } else {
          this.canHandleResetQuota = false
        }
      }
    },

    // 一键驳回权限
    setRejectAuth () {
      if (
        ((['210', '220', '230', '240', '250', '270'].includes(this.solutionStatus)) &&
          this.applyStatus === '200') ||
        (this.executionStatus === '330' && this.applyStatus === '300')
      ) {
        if (
          this.tradeApplyInfoVO.applyClientLevel === 60 &&
          this.defaultBuType === '03' &&
          this.employeeLevel === 60
        ) {
          this.canHandleReject = true
        } else if (
          this.tradeApplyInfoVO.applyClientLevel !== 60 &&
          (this.employeeLevel === 45 || this.employeeLevel === 50)
        ) {
          this.canHandleReject = true
        } else {
          this.canHandleReject = false
        }
      }

      if (this.tradeApplyOrderVO?.tradeApplyExecCooler) {
        this.canHandleReject = false
      }
    },

    // 关闭订单权限
    setCloseAuth () {
      if (['107', '108'].includes(this.execTypeSub)) return
      if (
        (this.applyStatus === '100' && Number(this.requirementStatus) < 140) ||
        ((['205', '210', '220', '230', '240', '250', '270'].includes(this.solutionStatus)) &&
          this.applyStatus === '200') ||
        (this.executionStatus === '330' && this.applyStatus === '300')
      ) {
        if (
          this.tradeApplyInfoVO.applyClientLevel === 60 &&
          this.defaultBuType === '03' &&
          this.employeeLevel === 60
        ) {
          this.canHandleClose = true
        } else if (
          this.tradeApplyInfoVO.applyClientLevel !== 60 &&
          (this.employeeLevel === 45 || this.employeeLevel === 50)
        ) {
          this.canHandleClose = true
        } else if (this.isStarCustom) {
          this.canHandleClose = true
        } else {
          this.canHandleClose = false
        }
      }

      if (
        this.tradeApplyOrderVO?.tradeApplyExecCooler &&
        this.executionStatus === '330' &&
        this.applyStatus === '300'
      ) {
        this.canHandleClose = false
      }
    },

    // 重设供应商
    handleReset () {
      if (this.tradeApplyOrderVO?.basePocInfo.abiPocId && this.tradeApplyOrderVO?.basePocInfo.abiPocStatus === 2) {
        this.$confirm('该门店已永久关店，不支持重设供应商，请关闭订单', '提示', {
          customClass: 'custom-message-box',
          confirmButtonText: '驳回',
          confirmButtonClass: 'custom-message-box-confirm-btn',
          cancelButtonClass: 'btn-red-plain',
          distinguishCancelAndClose: true,
          showClose: false,
          closeOnClickModal: false,
          callback: action => {
            if (action === 'confirm') {
              this.handleType = 'close'
              this.rejectReason = '该门店已永久关店'
              this.handleConfirm()
            }

          }
        })
        return
      }
      this.handleText = '是否确认重设供应商？'
      this.handleType = 'reset'
      this.dialogVisible = true
    },

    // 重选预算
    handleResetQuota () {
      this.handleText = '是否确认重选预算？'
      this.handleType = 'resetQuota'
      this.dialogVisible = true
    },

    // 一键驳回
    handleReject () {
      this.handleText = '是否确认重设供应商？'
      this.handleType = 'reject'
      this.rejectReason = ''
      this.dialogVisible = true
      this.handleTips = '填写驳回理由'
    },

    // 关闭订单
    handleClose () {
      this.handleText = '是否确认关闭订单？'
      this.handleType = 'close'
      this.rejectReason = ''
      this.dialogVisible = true
      this.handleTips = '填写关闭理由'
    },

    // 确认
    handleConfirm () {
      const formData = {
        applyId: this.tradeApplyOrderVO.applyId,
        processRemark: this.rejectReason,
        processClientName: this.userInfo.clientName
      }

      // 重设供应商
      if (this.handleType === 'reset') {
        this.$store.dispatch('handleReset', formData).then(res => {
          if (res.data.resultCode === '0') {
            this.dialogVisible = false
            this.successText = '操作成功!请重新选择供应商'
            this.succVisible = true
          }
        })
      }

      // 重选预算
      if (this.handleType === 'resetQuota') {
        this.$store.dispatch('handleResetQuota', formData).then(res => {
          if (res.data.resultCode === '0') {
            this.dialogVisible = false
            this.successText = '操作成功!请重新选择预算'
            this.succVisible = true
          }
        })
      }

      // 一键驳回
      if (this.handleType === 'reject') {
        if (!this.rejectReason) {
          this.$message.error('请填写驳回理由')
          return
        }
        this.$store.dispatch('handleReject', formData).then(res => {
          if (res.data.resultCode === '0') {
            this.dialogVisible = false
            this.successText = '一键驳回成功'
            this.succVisible = true
          }
        })
      }

      // 关闭订单
      if (this.handleType === 'close') {
        if (!formData.processRemark) {
          this.$message.error('请填写关闭理由')
          return
        }
        this.$store.dispatch('handleClose', formData).then(res => {
          if (res.data.resultCode === '0') {
            this.dialogVisible = false
            this.successText = '关闭订单成功'
            this.succVisible = true
          }
        })
      }
    },

    // 返回订单列表
    returnList () {
      this.$router.go(-1)
    },

    // 查看详情
    showInfo () {
      this.succVisible = false
      this.$router.go(0)
      this.$emit('handleSuccess')
    }
    // 获取禁用信息
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog {
  min-width: 430px;
}
.trade-order-block {
  .order-header {
    font-size: $font-16;
    margin-bottom: 15px;

    & > div {
      margin-bottom: 10px;
    }

    .order-name {
      font-size: 24px;
      font-weight: bold;
    }

    .order-close {
      color: $base-red;
      float: right;
      font-size: 16px;
    }

    .order-time {
      display: flex;
      justify-content: space-between;
    }

    .order-reject {
      font-size: 14px;

      div {
        margin-bottom: 10px;

        span {
          color: $base-red;
        }
      }
    }
  }

  .step-slot {
    border-top: solid 1px $base-grey3;
    border-bottom: solid 1px $base-grey3;
    padding-top: $content-large;
  }

  .order-btn {
    text-align: right;
    margin-top: $content-middle;
  }

  .order-number {
    display: flex;
    align-items: center;
    img {
      width: 21px;
      height: 21px;
      margin-left: 10px;
    }
  }
}
</style>
